import { useEffect, useMemo, useState } from 'react';

export default function useAppBoot() {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeApp = () => {
      setIsInitialized(true);
    };
    setTimeout(() => {
      initializeApp();
    }, 100);
  }, []);

  // Aggregate loading state
  const isAppLoading = useMemo(() => !isInitialized, [isInitialized]);
  return { isAppLoading };
}
